import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import UserEditor from './UserEditor';

function EditUser() {
	const { id } = useParams();
	const navigate = useNavigate();

	return (
		<EntityList>
			<Helmet>
				<title>Editar Usuario</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: 'Configuración', to: '/AdminScreen/Config' },
					{ label: 'Usuarios', to: '/AdminScreen/Config/usuarios' },
					{ label: 'Editar Usuario' },
				]}
				title='Editar Usuario'
				subtitle='Actualizá los datos principales del usuario.'
			/>
			<UserEditor
				mode='edit'
				userId={id}
				onCancel={() => navigate('/AdminScreen/Config/usuarios')}
				onSaved={() => navigate('/AdminScreen/Config/usuarios')}
				saveLabel='Guardar'
			/>
		</EntityList>
	);
}

export default EditUser;
